import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/ServiceLinesSlice';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.serviceline || initialState;

export const selectLoading = createSelector([selectDomain], (state) => state.loading);
export const selectServiceLines = createSelector(
  [selectDomain],
  (state) => state.followedServiceLines,
);
export const selectServiceLinesEmpty = createSelector(
  [selectDomain],
  (state) => state.serviceLinesEmpty,
);
export const selectRecommendedServiceLines = createSelector(
  [selectDomain],
  (state) => state.recommendedServiceLines,
);
export const selectFollowLoading = createSelector(
  [selectDomain],
  (state) => state.followLoading,
);

export const selectDetailLoading = createSelector(
  [selectDomain],
  (state) => state.detailLoading,
);
export const selectNewsLoading = createSelector(
  [selectDomain],
  (state) => state.newsArticlesLoading,
);
export const selectNewsTabPage = createSelector(
  [selectDomain],
  (state) => state.newsTabPage,
);
export const selectNewsArticles = createSelector(
  [selectDomain],
  (state) => state.newsArticles,
);
export const selectArticleNewsEnded = createSelector(
  [selectDomain],
  (state) => state.articleNewsEnded,
);
export const selectNewsFilter = createSelector(
  [selectDomain],
  (state) => state.newsFilter,
);
export const selectSelectedNewsFilter = createSelector(
  [selectDomain],
  (state) => state.selectedNewsFilter,
);

export const selectWidgetLoading = createSelector(
  [selectDomain],
  (state) => state.widgetLoading,
);

export const selectServicelineName = createSelector(
  [selectDomain],
  (state) => state.servicelineName,
);
export const selectPaginationLoader = createSelector(
  [selectDomain],
  (state) => state.paginationLoader,
);
export const selectServicelineAdded = createSelector(
  [selectDomain],
  (state) => state.servicelineAdded,
);
export const selectServicelineWidgets = createSelector(
  [selectDomain],
  (state) => state.serviceLineWidgets,
);
export const selectServicelineFilters = createSelector(
  [selectDomain],
  (state) => state.filters,
);
export const selectServicelineFiltersType = createSelector(
  [selectDomain],
  (state) => state.filtersType,
);
export const selectServicelineCompanies = createSelector(
  [selectDomain],
  (state) => state.companies,
);
export const selectServicelineCompaniesLoading = createSelector(
  [selectDomain],
  (state) => state.companiesLoading,
);
export const selectServicelineCompaniesCount = createSelector(
  [selectDomain],
  (state) => state.companiesCount,
);
export const selectServicelineCompanyAdded = createSelector(
  [selectDomain],
  (state) => state.companyAdded,
);
export const selectServicelineRegions = createSelector(
  [selectDomain],
  (state) => state.regions,
);
export const selectServicelineSelectedRegions = createSelector(
  [selectDomain],
  (state) => state.selectedRegions,
);
export const selectSLArticleAlerts = createSelector(
  [selectDomain],
  (state) => state.articleAlerts,
);



